import { ACTION_ARGS, MODAL_ARGS, Metadata, pick, pickAll } from '../../../utils/spds/metadata';
import {
  MODAL_DOCS_CTA_BLOCKS,
  assembleModalDescription,
} from '../../../utils/spds/metadata/modal-docs';
import { ensureSafeComponent } from '@embroider/util';
import { fn, hash } from '@ember/helper';
import { tracked } from '@glimmer/tracking';
import ModalCta from './shared/footer-cta.gjs';
import StandardModal from './standard.gjs';
import Super from '../core/base.gjs';

const METADATA = Metadata.define({
  description: assembleModalDescription(
    'A variant of our transactional modal used for destructive or irreversible actions.',
    MODAL_DOCS_CTA_BLOCKS
  ),
  extends: [
    pick(ACTION_ARGS, [{ name: 'onClose', required: true }, 'onBeforeClose', 'onOpen']),
    pickAll(MODAL_ARGS, {
      overrides: {
        primaryBtnText: { initialValue: 'Destructive button' },
        title: { initialValue: 'Destructive action' },
      },
    }),
  ],
  name: 'Destructive',
  resources: {
    figma:
      'https://www.figma.com/design/g4zf0Vkj39VcCyleokv2rl/%E2%9D%96-Air-web-components?node-id=25680-18273&m=dev',
    zeroheight: 'https://www.simplepractice.design/1d0abbc0a/p/380570-modal',
  },
});

export default class SpdsModalDestructive extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal-destructive';

  @tracked footerComponent;

  get showStandardFooter() {
    let { primaryBtnAction, primaryBtnText, secondaryBtnAction, secondaryBtnText } = this.args;

    return (
      !this.footerComponent &&
      (primaryBtnAction || primaryBtnText || secondaryBtnAction || secondaryBtnText)
    );
  }

  <template>
    <StandardModal
      @closeOnClickOutside={{@closeOnClickOutside}}
      @id={{this.id}}
      @onBeforeClose={{@onBeforeClose}}
      @onClose={{@onClose}}
      @onOpen={{@onOpen}}
      @variantName={{this.componentName}}
      class={{this.classes}}
      data-test-spds-modal-destructive
      {{this.validateArguments}}
      ...attributes
      as |M|
    >
      {{yield
        (hash
          Header=(ensureSafeComponent M.Header)
          Body=(ensureSafeComponent M.Body)
          Footer=(ensureSafeComponent
            M.Footer
            registerComponent=(fn this.registerComponent "footerComponent")
            unregisterComponent=(fn this.unregisterComponent "footerComponent")
          )
          beforeClose=M.beforeClose
          close=M.close
        )
      }}

      {{#if this.showStandardFooter}}
        <M.Footer>
          <ModalCta
            @close={{M.close}}
            @danger={{true}}
            @primaryBtnAction={{@primaryBtnAction}}
            @primaryBtnText={{@primaryBtnText}}
            @primaryBtnDisabled={{@primaryBtnDisabled}}
            @secondaryBtnAction={{@secondaryBtnAction}}
            @secondaryBtnText={{@secondaryBtnText}}
            @secondaryBtnDisabled={{@secondaryBtnDisabled}}
          />
        </M.Footer>
      {{/if}}
    </StandardModal>
  </template>
}

export const MODAL_DESTRUCTIVE_METADATA = SpdsModalDestructive.metadata;
